<template>
    <ion-loading
        :is-open="isLoading"
        spinner="crescent"
    />
</template>

<script setup lang="ts">
    import { IonLoading } from '@ionic/vue';
    import { onMounted, onUnmounted, ref } from 'vue';

    const isLoading = ref(false);

    const handleLoadingStart = () => {
        isLoading.value = true;
    };

    const handleLoadingStop = () => {
        isLoading.value = false;
    };

    onMounted(() => {
        window.addEventListener('api-loading-start', handleLoadingStart);
        window.addEventListener('api-loading-stop', handleLoadingStop);
    });

    onUnmounted(() => {
        window.removeEventListener('api-loading-start', handleLoadingStart);
        window.removeEventListener('api-loading-stop', handleLoadingStop);
    });
</script>
